import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { AdditionalSeatsStartAtText } from 'pricing-pages-ui-components/seats/AdditionalSeatsStartAtText';
import { IncludedSeats } from 'pricing-pages-ui-components/seats/IncludedSeats';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IncludedSeatsDisplay = ({
  includedCoreSeats,
  includedSalesSeats,
  includedServiceSeats,
  includedCommerceSeats,
  showIncludedSeats,
  showAdditionalSeatsPriceSubtext,
  additionalCoreSeatsPrice,
  currencyCode,
  currencyCodeUnit
}) => {
  if (!showIncludedSeats && !showAdditionalSeatsPriceSubtext) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    children: [showIncludedSeats && /*#__PURE__*/_jsx(Text, {
      typography: "body-125",
      children: /*#__PURE__*/_jsx(IncludedSeats, {
        includedSalesSeats: includedSalesSeats,
        includedServiceSeats: includedServiceSeats,
        includedCoreSeats: includedCoreSeats,
        includedCommerceSeats: includedCommerceSeats
      })
    }), showAdditionalSeatsPriceSubtext && /*#__PURE__*/_jsx(AdditionalSeatsStartAtText, {
      price: additionalCoreSeatsPrice,
      currencyCode: currencyCode,
      currencyCodeUnit: currencyCodeUnit,
      seatQuantityType: "CORE_SEAT"
    })]
  });
};